module.exports = __webpack_public_path__ + "static/media/ryebridge-logo.24bf6c29.svg";